import templateUrl from './owner-modal.component.html';
//import "./onboarding-document-w4-form.component.less";

export const OwnerModalComponent = {
    templateUrl,
    controller: OwnerModalController,
    controllerAs: "vm",
    bindings: {
        resolve: '<',
        //close: '&',
        //dismiss: '&'
    }
}

function OwnerModalController($state, $stateParams, utilityService, $rootScope, $scope) {
    'ngInject'
    const vm = this;
    vm.modalTitle;
    vm.currentState;
    vm.empState;
    //vm.modalTitle;
    //vm.dismiss = dismiss;
    //vm.closeModal = closeModal;

    vm.$onInit = function () {
        //vm.modalTitle = this.resolve.modalTitle;
        //vm.application = this.resolve.application;
        //utilityService.showLoading();
        vm.modalTitle = $state.current.data.pageHeader;
        vm.currentState = $state.current.name;
        switch (vm.resolve.employeeBankInfo.StateAbbrevation) {
            case 'AR':
                vm.empState = 'AR';
                break;
            case 'AL':
                vm.empState = 'AL';
                break;
            case 'AZ':
                vm.empState = 'AZ';
                break;
            case 'NY':
                vm.empState = 'NY';
                break;
            case 'KY':
                vm.empState = 'KY';
                break;
            default:
                vm.empState = 'def';
                break;
        }
        utilityService.hideLoading();
    }

    $rootScope.$on('childStateChanged', function (event, data) {
        // Update the parent component's state based on the data received
        //vm.currentState = data.newState;
        /*$state.go(data.newState);*/
        vm.modalTitle = $state.current.data.pageHeader;
        vm.currentState = data.newState;
        if (data.newState.includes('application-status.ownermodal.provinceW4')) {
            switch (data.state) {
                case 'AR':
                    vm.empState = 'AR';
                    break;
                case 'AL':
                    vm.empState = 'AL';
                    break;
                case 'AZ':
                    vm.empState = 'AZ';
                    break;
                case 'NY':
                    vm.empState = 'NY';
                    break;
                case 'KY':
                    vm.empState = 'KY';
                    break;
                default:
                    vm.empState = 'def';
                    break;

            }
        }
        // Perform any other actions based on the state change
        // ...
    });

    //$rootScope.$on('setState', function (event, data) {
    //    switch (data.state) {
    //        case 'AR':
    //            vm.empState = 'AR';
    //            break;
    //        default:
    //            vm.empState = 'def';
    //            break;
    //    }
    //});

    //vm.stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    //    // This function will be called on every successful state change
    //    console.log('State changed from', fromState.name, 'to', toState.name);

    //    // You can perform additional actions here based on the state change
    //    // For example, update some variables, make API calls, etc.
    //}); 

    //$rootScope.$on('$destroy', vm.stateChangeSuccessListener);

    vm.dismiss = function () {
        //vm.modalInstance.close();
        return $state.go("application-status");
    }

    //vm.onClose = function() {
    //    this.dismiss({ $value: 'close' });
    //}
    //$rootScope.$on('childStateChanged', function (event, data) {
    //    // Update the parent component's state based on the data received
    //    //vm.currentState = data.newState;
    //    /*$state.go(data.newState);*/
    //    vm.modalTitle = $state.current.data.pageHeader;
    //    vm.currentState = data.newState;
    //    // Perform any other actions based on the state change
    //    // ...
    //});

    //$rootScope.$on('setState', function (event, data) {
    //    switch (data.state) {
    //        case 'AR':
    //            vm.empState = 'AR';
    //            break;
    //        default:
    //            vm.empState = 'def';
    //            break;
    //    }
    //});
}


export const ApexOwnerModal = {
    component: "apexOwnerModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
};
